// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3tMTu","label":"CategoryService_label__3jUWd","location":"CategoryService_location__2RPRR"};